import { render, staticRenderFns } from "./advtisement.vue?vue&type=template&id=7af28468&scoped=true"
import script from "./advtisement.vue?vue&type=script&lang=js"
export * from "./advtisement.vue?vue&type=script&lang=js"
import style0 from "./advtisement.vue?vue&type=style&index=0&id=7af28468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af28468",
  null
  
)

export default component.exports